/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import Translate from 'react-translate-component';
import { SupplierLedgerService } from 'frilans-finans';
import GeneralError from 'components/general-error/general-error';
import Spinner from 'components/spinner/spinner';
import Utils from 'frilans-finans/utils/utils';
import { Link } from 'react-router';

export class SupplierLedger extends React.Component {

  static propTypes = {
    params: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      fetching: true,
      fetchError: false
    };
  }

  componentDidMount () {
    this.fetchDeduction();
  }

  fetchDeduction () {
    this.setState({
      fetching: true
    });
    SupplierLedgerService.getById(this.props.params.id)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  }

  handleResponse (response) {
    this.setState({
      fetching: false,
      fetchError: false,
      deduction: response
    });
  }

  handleError () {
    this.setState({
      fetchError: true
    });
  }

  getContent () {
    if (this.state.fetchError) {
      return (<GeneralError />);
    }
    if (this.state.fetching) {
      return this.renderLoader();
    }

    return this.renderTable();
  }

  renderLoader () {
    return (
      <div className='loader-wrapper'>
        <Spinner />
      </div>
    );
  }

  renderTable () {
    return (
      <div>
        <h2>{this.state.deduction.supplierName}</h2>
        <table className='slim-table'>
          <tbody>
            <tr>
              <td><Translate content='LEV_ID'/></td>
              <td>{this.state.deduction.id}</td>
            </tr>
            <tr>
              <td><Translate content='ORDER_NR'/></td>
              <td>{this.state.deduction.invoiceId}</td>
            </tr>
            <tr>
              <td><Translate content='ARRIVED'/></td>
              <td>{Utils.formatDate(this.state.deduction.arrivedDate)}</td>
            </tr>
            <tr>
              <td><Translate content='STATUS'/></td>
              <td>{this.state.deduction.statusText}</td>
            </tr>
            <tr>
              <td><Translate content='PAID_DATE'/></td>
              <td>{Utils.formatDate(this.state.deduction.payedDate)}</td>
            </tr>
            <tr>
              <td><Translate content='SUM'/></td>
              <td>{this.state.deduction.amount} <Translate content='SEK_SHORT'/></td>
            </tr>
          </tbody>
        </table>

        <img src={this.state.deduction.file ? this.state.deduction.file.attributes.file_src : ''} alt=''/>

        <Link className='btn blue outlined' to='/economy/supplier-ledgers'><Translate content='BACK'/></Link>
      </div>
    );
  }

  render () {
    var content = this.getContent();

    return (
      <div className='deduction'>

        {content}

      </div>
    );
  }
}

export default SupplierLedger;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/supplier-ledgers/supplier-ledger.js
 **/